import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { cityEditAction, citySearchAction } from './actions/CityActions';
import CityForm from './CityForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.cityManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.citySearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.cityManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="master.city_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<CityForm />}
            />
        ),
    },
    {
        link: RoutingUtil.citySearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.city_manager.search"
                editScope="master.city_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="CityReducer"
                dataPath="search"
                editAction={cityEditAction}
                redirectUrlOnEdit={RoutingUtil.cityManagerUrl()}
                action={citySearchAction}
                columns={{
                    cityName: {
                        display: 'City Name',
                    },
                    cityType: {
                        display: 'City Type',
                    },
                    lat: {
                        display: 'Lat',
                    },
                    lng: {
                        display: 'Lng',
                    },
                    pincode: {
                        display: 'Pincode',
                    },
                    stateId: {
                        display: 'State',
                        path: 'stateName',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const CityContainer = () => (
    <CrudLayoutContainer
        title="City Manager"
        tabs={tabs}
        routes={routes}
    />
);

CityContainer.propTypes = {
};

export default CityContainer;
